export default __webpack_public_path__ + "img/chUjuhAm.2445109b.svg";